<template>
  <vs-row vs-type="block" vs-w="12" id="dashBoardCategoryReport" class="py-1">
    <branch-product-report-viewer @getExcel="getExcelPersonalReportAccordingTo" @openVariantPopup="openVariantPopup" ref="branchProductReportViewer"
                                  :report="selectedCategory" @close="selectedCategory = {}"/>
                                  <variant-popup :variantPopup="variantPopup" :variantSums="variantSums" @close="variantPopup=false" ref="variantPopup"/>
                                      <span v-if="!stop" class="w-full text-xsmall text-secondary bold">
      Kategori Bazlı Ciro Raporu
    </span>
    <vs-row vs-type="flex" vs-w="12" id="productReportFilter" class="my-2" v-if="stop">
      <vs-input v-model="filterString" class="w-full border-radius border-all" placeholder="Ürün Arama"/>
    </vs-row>
    <vs-row class="weight-600 text-smaller border-bottom border-secondary py-1">
      <vs-col vs-w="4" vs-type="flex" vs-justify="start">
        <span>
          İsim
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Adet
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Ciro
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Maaliyet
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Kar
        </span>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="py-1"
            v-for="(category,index) in (filteredList && filteredList.length > 0 ? filteredList : [])" :key="index">
      <div @click="getPersonalReportAccordingTo(category)"
           class="d-flex w-full text-xsmall justify-between cursor-pointer border-bottom border-secondary py-1">
        <vs-col vs-type="flex" vs-w="4" vs-align="center">
          <span class="text-primary mr-2 text-xsmall weight-600">
            {{ (index + 1) + '.' }}
          </span>
          <span class="text-primary text-xsmall weight-600">
            {{ category.typeValue }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 1}"
                class="text-secondary weight-600 w-full text-center">
            {{ category.piece.toLocaleString() }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 0}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(category.amount) }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 2}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(category.cost) }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 3}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(category.profit) }}
          </span>
        </vs-col>
      </div>
    </vs-row>
    <vs-row v-if="!stop" vs-type="flex" vs-w="12" class="pt-3" vs-justify="center" vs-align="center">
      <span @click="openDetailPage" class="text-secondary text-xsmaller bold underline cursor-pointer">
        Detay Sayfasına Git
      </span>
    </vs-row>
    <vs-row v-else vs-type="flex" vs-w="12" class="py-1 border-bottom border-secondary text-secondary text-smaller" vs-align="center">
      <vs-col vs-type="flex" vs-w="4" vs-align="center">
        <span class="text-dark text-smaller bold">
        Toplam
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 1}" class="underline bold">
        {{ totalQuantity.toLocaleString() }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 0}" class="underline bold">
          {{ $convertCurrency(totalAmount) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 2}" class="underline bold">
          {{ $convertCurrency(totalCost) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 3}" class="underline bold">
          {{ $convertCurrency(totalProfit) }}
        </span>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import {getReportTypes} from '@/model/constants/dashboardModels'
import {GetPersonalReportAccordingTo,GetBranchProductSizesReportAccordingTo,GetPersonalReportAccordingToForDealer, GetExcelPersonalReportAccordingTo,GetExcelPersonalReportAccordingToForDealer} from '@/api/Reports'
import BranchProductReportViewer from '../BranchProductReportViewer'
import VariantPopup from '../VariantPopup'
import GiroInfo from '../GiroInfo'

export default {
  components: {
    BranchProductReportViewer,
    VariantPopup,
    GiroInfo
  },
  props: {
    stop: {
      type: Boolean,
      required: true
    },
    reportData: {
      type: Array,
      required: true
    },
    orderBy: {
      type: Number,
      required: true
    },
    tableOptions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterString: null,
      reportTypes: getReportTypes(),
      selectedCategory: {},
      selectedVariant: {},
      variantSums: {},
      variantPopup : false
    }
  },
  methods: {
    closePopup() {
      // Popup'ı kapat
      this.variantPopup = false;
    },
    openVariantPopup(id,accordingId){
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 2).name
      tableParams.accordingId = accordingId;
      GetBranchProductSizesReportAccordingTo(tableParams,id).then(res => {
        this.variantSums = res.data;
      })
      this.variantPopup = true;
    }
    ,
    getExcelPersonalReportAccordingTo(accordingId) {
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 2).name
      tableParams.accordingId = accordingId;
      if (this.$isRegionalCenterBranch()) {
        GetExcelPersonalReportAccordingToForDealer(tableParams).then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Kategori Şube Raporu' + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Kategori Şube Excel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      } else {
        GetExcelPersonalReportAccordingTo(tableParams).then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Kategori Şube Raporu' + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Kategori Şube Excel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      }
     
    },
    getPersonalReportAccordingTo(according) {
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 2).name
      tableParams.accordingId = according.typeId;
      if (this.$isRegionalCenterBranch()) {
        GetPersonalReportAccordingToForDealer(tableParams).then(res => {
        if (res && res.status === 200) {
          this.selectedCategory.list = res.data.list
          this.selectedCategory.variantSums = res.data.variantSums
          if (this.tableOptions.defaultTimeRange) {
            this.selectedCategory.date = this.tableOptions.defaultTimeRange.dName
          } else {
            this.selectedCategory.date = this.tableOptions.dateRange.startDate + ' - ' + this.tableOptions.dateRange.endDate
          }
          this.selectedCategory.type = this.reportTypes.find(x => x.name === 'Category')
          this.selectedCategory.orderBy = this.tableOptions.reportByProp ? this.tableOptions.reportByProp.id : 0
          if (this.tableOptions.branch) this.selectedCategory.branch = this.tableOptions.branch
          this.selectedCategory.accordingTo = according
          this.$refs.branchProductReportViewer.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Kategori Personel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      } else {
        GetPersonalReportAccordingTo(tableParams).then(res => {
        if (res && res.status === 200) {
          this.selectedCategory.list = res.data.list
          this.selectedCategory.variantSums = res.data.variantSums
          if (this.tableOptions.defaultTimeRange) {
            this.selectedCategory.date = this.tableOptions.defaultTimeRange.dName
          } else {
            this.selectedCategory.date = this.tableOptions.dateRange.startDate + ' - ' + this.tableOptions.dateRange.endDate
          }
          this.selectedCategory.type = this.reportTypes.find(x => x.name === 'Category')
          this.selectedCategory.orderBy = this.tableOptions.reportByProp ? this.tableOptions.reportByProp.id : 0
          if (this.tableOptions.branch) this.selectedCategory.branch = this.tableOptions.branch
          this.selectedCategory.accordingTo = according
          this.$refs.branchProductReportViewer.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Kategori Personel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      }
     
    },
    openDetailPage() {
      this.$router.push('/pages/reports/category-report').catch(() => {
      })
    },
    getImage(image) {
      if (!image) return this.$nullImage;
      else return this.$baseUrl + '/' + image;
    },
  },
  computed: {
    totalQuantity() {
      return this.filteredList.reduce((total, num) => total + num.piece, 0);
    },
    totalAmount() {
      return this.filteredList.reduce((total, num) => total + num.amount, 0);
    },
    totalCost() {
      return this.filteredList.reduce((total, num) => total + num.cost, 0);
    },
    totalProfit() {
      return this.filteredList.reduce((total, num) => total + num.profit, 0);
    },
    filteredList() {
      if (!this.reportData) return [];
      if (!this.filterString) return this.reportData;
      return this.reportData.filter(x => x.typeValue.toLowerCase().includes(this.filterString.toLowerCase()));
    }
  }
}

</script>

<style>
#categoryReportThird,
#categoryReportSecond {
  padding-top: 2.5rem;
}

</style>
